import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, inject, OnInit } from '@angular/core';
import { Route, Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatRipple } from '@angular/material/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';
import { FullLengthMenuComponent } from '@dges/ui/full-length-menu';
import { DropDownMenuComponent } from '@dges/ui/drop-down-menu';
import { LogoComponent } from 'logo';
import { LayoutComponent } from '@dges/ui/layout';
import { BackgroundComponent } from '@dges/ui/background';

@Component({
  selector: 'dges-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    LayoutComponent,
    RouterLink,
    RouterOutlet,
    MatRipple,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatIcon,
    NgTemplateOutlet,
    LogoComponent,
    FullLengthMenuComponent,
    DropDownMenuComponent,
    BackgroundComponent,
  ],
})
export class AppComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  private router = inject(Router);

  public fillerNav: Route[] = [];
  public showFullMenu = false;

  ngOnInit(): void {

    console.warn('I want to test rerun. AppComponent initialized');
    this.fillerNav.push(...this.router.config.filter((route) => route.path));

    this.breakpointObserver
      .observe(['(min-width: 850px)'])
      .subscribe((state: BreakpointState) => {
        this.showFullMenu = state.matches;
      });
  }
}
